import { render, staticRenderFns } from "./SimpleCartSummary.vue?vue&type=template&id=6138e83c&"
import script from "./SimpleCartSummary.vue?vue&type=script&lang=js&"
export * from "./SimpleCartSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports